import { render } from "./BlockedFileExtensions.vue?vue&type=template&id=64f544f2&scoped=true"
import script from "./BlockedFileExtensions.vue?vue&type=script&lang=js"
export * from "./BlockedFileExtensions.vue?vue&type=script&lang=js"

import "./BlockedFileExtensions.vue?vue&type=style&index=0&id=64f544f2&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f544f2"]])

export default __exports__